import { render, staticRenderFns } from "./CharSheetDetail.vue?vue&type=template&id=649b66b2&"
import script from "./CharSheetDetail.vue?vue&type=script&lang=js&"
export * from "./CharSheetDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports